module.exports = __webpack_public_path__ + "static/media/ins-3.446d0971.jpg";